import { useMemo, useState } from 'react'
import { Button } from '@/components/ui/Button'
import { CsField, CsSection } from '@/components/Cs/CsSection'
import { csFieldClass } from '@/components/Cs/csFormStyles'
import type { CsAccountDetail } from '@/services/csService'

type Props = {
  account: CsAccountDetail
  onCreate: (payload: { score: number; comentario?: string | null }) => Promise<void>
}

export function CsAccountNps({ account, onCreate }: Props) {
  const [score, setScore] = useState(9)
  const [comentario, setComentario] = useState('')

  const evolution = useMemo(() => {
    return [...account.nps].reverse()
  }, [account.nps])

  const maxBar = 10

  return (
    <CsSection title='NPS'>
      <div className='mb-4 flex flex-wrap gap-2'>
        <CsField label='Nota'>
          <select className={csFieldClass} value={score} onChange={(e) => setScore(Number(e.target.value))}>
            {Array.from({ length: 11 }, (_, i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </CsField>
        <div className='min-w-[200px] flex-1'>
          <CsField label='Comentário'>
            <input
              className={csFieldClass}
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              placeholder='Opcional'
            />
          </CsField>
        </div>
        <div className='flex items-end'>
          <Button
            size='sm'
            variant='primary'
            onClick={() =>
              void onCreate({ score, comentario: comentario.trim() || null }).then(() => setComentario(''))
            }
          >
            Registrar NPS
          </Button>
        </div>
      </div>

      {evolution.length > 0 && (
        <div className='mb-4'>
          <p className='mb-2 text-xs font-medium text-[var(--text-muted)]'>Evolução das respostas</p>
          <div className='flex h-24 items-end gap-1'>
            {evolution.map((n) => (
              <div key={n.id} className='flex flex-1 flex-col items-center gap-1' title={`${n.score}/10`}>
                <div
                  className='w-full max-w-[28px] rounded-t bg-accent/70'
                  style={{ height: `${Math.max(8, (n.score / maxBar) * 100)}%` }}
                />
                <span className='text-[10px] text-[var(--text-muted)]'>{n.score}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {account.nps.length === 0 ? (
        <p className='text-sm text-[var(--text-muted)]'>Nenhuma resposta ainda.</p>
      ) : (
        <ul className='space-y-2'>
          {account.nps.map((n) => (
            <li key={n.id} className='rounded-lg border border-[var(--glass-border)] px-3 py-2 text-sm'>
              <span className='font-semibold'>{n.score}/10</span>
              <span className='ml-2 text-[var(--text-muted)]'>
                {new Date(n.respondidoEm).toLocaleDateString('pt-BR')}
              </span>
              {n.comentario && <p className='mt-1 text-[var(--text-muted)]'>{n.comentario}</p>}
            </li>
          ))}
        </ul>
      )}
    </CsSection>
  )
}
